module.exports = __webpack_public_path__ + "media/images/night-life-2b1ef69bda904e443ce69d0aefc6d070.jpg";